import React, { Component } from "react";
import { Link } from "react-router-dom";
import { BudgetStatus, ProjectMode, ProjectType } from "../../../utils/enums";
import { RouteUrls } from "../../../configs/routeUrls";

export class HighlightProject extends Component {
  constructor(props) {
    super(props);
    this.getProjectTypeSettings = (
      type,
      isAuth = false,
      availableVoteNotLogged = false,
      isLegalAgeUser = false,
      isUserCitizen = false,
      onlyForLegalAge = false,
      mode = ProjectMode.NotSetted,
      status,
      isVoted = false
    ) => {
      switch (type) {
        case ProjectType.Consultation:
          return {
            url:
              mode === ProjectMode.Open ||
              (mode !== ProjectMode.Open &&
                (onlyForLegalAge ? isAuth && isLegalAgeUser : isAuth))
                ? RouteUrls.Consultation.voteFunc(this.props.id)
                : RouteUrls.Consultation.previewFunc(this.props.id),
            name: "Konsultacja",
            colorClass: "bag--primary",
          };
        case ProjectType.Survey:
          return {
            url:
              mode === ProjectMode.Open ||
              (mode !== ProjectMode.Open &&
                (onlyForLegalAge ? isAuth && isLegalAgeUser : isAuth))
                ? RouteUrls.Survey.voteFunc(this.props.id)
                : RouteUrls.Survey.previewFunc(this.props.id),
            name: "Ankieta",
            colorClass: "bag--secondary",
          };
        case ProjectType.PublicBudget:
          const isBudgetFinished = status === BudgetStatus.Finished;
          const isCitizenMode = mode === ProjectMode.Citizen;
          const meetsLegalAgeRequirement = onlyForLegalAge
            ? isAuth && isLegalAgeUser && isUserCitizen
            : isAuth && isUserCitizen;

          const canVote =
            !isVoted &&
            (!isBudgetFinished ||
              (availableVoteNotLogged && !isAuth) ||
              (isCitizenMode && meetsLegalAgeRequirement));

          return {
            url: canVote
              ? RouteUrls.Budget.vote.voteFunc(
                  this.props.budgetYear,
                  this.props.id
                )
              : RouteUrls.Budget.vote.previewFunc(
                  this.props.budgetYear,
                  this.props.id
                ),
            name: "Budżet",
            colorClass: "bag--danger",
          };
        default:
          return {
            url: "",
            name: "",
            colorClass: "",
          };
      }
    };
  }

  render() {
    const {
      isAuth,
      availableVoteNotLogged = false,
      isLegalAgeUser = false,
      isUserCitizen = false,
      onlyForLegalAge = false,
      mode = ProjectMode.NotSetted,
      status,
      isVoted,
    } = this.props;
    let { url } = this.getProjectTypeSettings(
      this.props.type,
      isAuth,
      availableVoteNotLogged,
      isLegalAgeUser,
      isUserCitizen,
      onlyForLegalAge,
      mode,
      status,
      isVoted
    );

    return (
      <Link
        className="cases__case"
        to={url}
        title={`Przejdź do strony z projektem ${this.props.title}`}
      >
        <i className="fa fa-chevron-right cases__arrow" aria-hidden="true" />
        <span
          className="cases__text cases__text--primary-dark"
          aria-hidden="true"
        >
          {this.props.title}
        </span>
      </Link>
    );
  }
}
